import { Alert, Button, Card, Col, Form, Input, Row, Space, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { fullWidthStyle, titleStyle } from "../constants/style";
import { useContext, useState } from "react";
import { SubmitStatus } from "../api/work-order-api";
import ApiContext from "../api/context";
import { useNavigate } from "react-router-dom";
import Link from "antd/es/typography/Link";
import Paragraph from "antd/es/typography/Paragraph";
import { useForm } from "antd/es/form/Form";

const widthStyle = {
  width: "325px"
};

export default function () {
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const [error, setError] = useState<String | undefined>(undefined);
  const [form] = useForm();
  const { api, setToken } = useContext(ApiContext);
  const navigate = useNavigate();
  const hasValidEmailAddress = emailAddress.trim() !== "";
  const hasValidPassword = password !== "";
  const isSubmitting = submitStatus !== SubmitStatus.Idle;
  const canLogin = !isSubmitting && hasValidEmailAddress && hasValidPassword;

  return (
    <div style={{ position: "fixed", width: "100%", height: "100vh" }}>
      <Title />
      <Row justify="center">
        <Col>
          <Card style={widthStyle}>
            <Spin spinning={isSubmitting}>
              <Title style={titleStyle} level={4}>
                Login
              </Title>
              <Form
                form={form}
                title="login"
                name="login"
                layout="vertical"
                onKeyDown={e => {
                  const isEnter = e.key === "Enter";
                  if (!isEnter) {
                    return;
                  }
                  
                  if (!canLogin) {
                    return;
                  }

                  form.submit();
                }}
                onFinish={e => {
                  setSubmitStatus(SubmitStatus.Submitting);
                  api?.login(emailAddress, password).then(loginResponse => {
                    const isGood = loginResponse.good();
                    if (!isGood) {
                      if (loginResponse.status === 401) {
                        setError("Either the password was incorrect or the account with the provided email address does not exist.");
                      } else {
                        setError("There was a problem while trying to login.");
                      }

                      setPassword("");
                      setSubmitStatus(SubmitStatus.Idle);
                      return;
                    }

                    // Store the token here somewhere.
                    const token = loginResponse.body ?? "";
                    localStorage.setItem("token", token);
                    setToken(token);
                    navigate("/");
                  }).catch(() => {
                    setSubmitStatus(SubmitStatus.Idle);
                  });
                }}
                colon={false}>
                <Form.Item label="Email Address">
                  <Input
                    placeholder="Enter your email address"
                    disabled={isSubmitting}
                    value={emailAddress}
                    onChange={e => setEmailAddress(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label="Password">
                  <Input
                    placeholder="Enter your password"
                    type="password"
                    disabled={isSubmitting}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </Form.Item>
                <Row style={fullWidthStyle} justify="space-between" align="middle">
                  <Link onClick={() => {
                    navigate("/passwordreset");
                  }}>Reset Password</Link>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!canLogin}>
                    Login
                  </Button>
                </Row>
              </Form>
            </Spin>
          </Card>
          {
            !error ? undefined :
              <>
                <Paragraph></Paragraph>
                <Alert style={widthStyle} type="error" message={error} />
              </>
          }
        </Col>
      </Row>
    </div>
  );
}